(function(){
  document.documentElement.classList.add('js');

  // Header Schatten beim Scrollen
  var header=document.querySelector('[data-header]');
  if(header){
    var onScroll=function(){header.classList.toggle('is-scrolled',window.scrollY>4)};
    onScroll();window.addEventListener('scroll',onScroll,{passive:true});
  }

  // Mobile Navigation
  var toggle=document.querySelector('[data-menu-toggle]');
  var mnav=document.getElementById('mobile-nav');
  if(toggle&&mnav){
    toggle.addEventListener('click',function(){
      var open=toggle.getAttribute('aria-expanded')==='true';
      toggle.setAttribute('aria-expanded',String(!open));
      mnav.hidden=open;
    });
    mnav.addEventListener('click',function(e){
      if(e.target.closest('a')){toggle.setAttribute('aria-expanded','false');mnav.hidden=true;}
    });
  }

  // Produktgalerie
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main=g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        main.src=btn.dataset.src;
        if(btn.dataset.srcset){main.srcset=btn.dataset.srcset}else{main.removeAttribute('srcset')}
        main.alt=btn.dataset.alt||'';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function(b){b.setAttribute('aria-current','false')});
        btn.setAttribute('aria-current','true');
      });
    });
  });

  // Einblend-Animation
  var els=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-visible');io.unobserve(en.target);}});
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el)});
  }else{els.forEach(function(el){el.classList.add('is-visible')});}

  // Nach erfolgreichem Formularversand zum Formular scrollen
  if(location.search.indexOf('contact_posted=true')>-1){
    var ok=document.querySelector('.form-success');
    if(ok){ok.scrollIntoView({block:'center'});}
  }
})();
